import {
  Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, QueryList, Input
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/security/services/authentication.service';
import { BaseConfig, FunctionEnable } from 'src/app/services/base-config.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { UserCache } from 'src/app/services/user-cache';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { WebApiService } from 'src/app/services/web-api.service';
import { MainLayoutService } from '../services/main-layout.service';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { HcrService, VisionApiResult } from 'src/app/services/hcr-service.service';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { StartUpService, VPNState } from 'src/app/services/start-up-service';
import { LoginMenu } from 'src/app/permission/models/login-menu';
import { SignalRService } from 'src/app/services/signalr-service';
import { HubConnectionState } from '@microsoft/signalr';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { SessionService } from 'src/app/services/session.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { DebugNotifyService } from 'src/app/services/debug-notify.service';
import { MemoryCache } from 'src/app/services/memory-cache-service';
import { TwoFactorDesc, TwoFactorValue, UserApi, UserSecurity } from 'src/app/services/api-service/user/user-api';
import { SatellitePharmacyServiceService } from 'src/app/services/satellite-pharmacy-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() menuItems: LoginMenu[];

  get isConn() {
    return this.signalRService.State == HubConnectionState.Connected;
  }
  get IsDebug() {
    var d = BaseConfig.isDebug();
    return d
  }
  get isDentist() {
    return UserCache.IsDentistMode();
  }
  isMws: boolean = false;
  version = '';
  versionTip = '';
  versionCls = '';
  headerPharName = '';
  constructor(private authService: AuthenticationService,
    private router: Router,
    private routeInfo: RouteInfoService,
    private mainLayoutService: MainLayoutService,
    private notificationDI: EasyNotificationService,
    private userConfirm: UserConfirmService,
    private webApiFactory: WebApiClient,
    private ezForm: EasyFormService,
    private startUpService: StartUpService,
    private signalRService: SignalRService,
    private sessionService: SessionService,
    private memcache: MemoryCache,
    private clinicData: ClinicDataService,
    private api2: DebugNotifyService,
    private userApi: UserApi,
    private hcrService: HcrService,
    private satelliteService:SatellitePharmacyServiceService
  ) {
    var cf = BaseConfig.getConfig();
    this.version = 'v' + cf.version;
    this.versionTip = '已為最新版本';
    if (cf.version != cf.latestVersion) {
      this.versionTip = '有新版本可用(v' + cf.latestVersion + ')，請重新整理網頁或者重新登入系統';
      this.versionCls = 'has-new-version'
      this.notificationDI.showWarning(this.versionTip, false);
    }
    var overScale = window.devicePixelRatio > 1.5 || window.devicePixelRatio < 0.75;
    if (overScale) {
      this.notificationDI.showWarning('注意！瀏覽器縮放大小不在 75% ~ 150%之範圍內恐引起顯示/操作異常。', false)
    }
    //this.versionCls = 'has-new-version'
    this.isShowMenuSubscription = this.mainLayoutService.isShowMenu$.subscribe(
      isShowMenu => {
        this.isShowMenu = isShowMenu;
        //console.log('isShowMenu:', isShowMenu);
      }
    );
    this.isShowPharSubscription = this.startUpService.onReloadSelectPhar.subscribe(async n => {
      this.getNowPharName();
    })
    /* this.switchMenuSubscription = this.mainLayoutService.switchMenu$.subscribe(
      (b) => {
        if(b){
          this.isShowMenu = !this.isShowMenu;
          console.log('isShowMenu2:',this.isShowMenu);
        }
      }
    ); */
    this.api = this.webApiFactory.createHisService('system/authenticate');
  }


  api: WebApiService;
  private unsubscribe: Subject<void> = new Subject();

  companyName = '';
  clinicName = '';
  userName = '';
  companyCode = '';
  clinicCode = '';
  customerServiceExt = '';

  private isShowMenuSubscription: Subscription;
  private isShowPharSubscription: Subscription;
  //private switchMenuSubscription: Subscription;

  get isUseTopMenu(): boolean {
    var mType = BaseConfig.getConfig().env.menuType;
    if (mType === 'top') {
      return true;
    } else {
      return false;
    }
  }
  isShowMenu = true;
  isShowUserMenu = false;
  isEnableChangeClinic = BaseConfig.getConfig().env.isEnableChangeClinic;
  anchorAlign = { horizontal: 'right', vertical: 'bottom' };
  popupAlign = { horizontal: 'right', vertical: 'top' };

  allowedClinics = [];
  isOpenChangeClinicDialog = false;
  logopath: string;
  logopathfg = true;

  @ViewChild('userLabel', { static: false }) public userLabel: ElementRef;
  @ViewChild('userMenu', { read: ElementRef, static: true }) public userMenu: ElementRef;

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @ViewChild('popup')
  popup: MatMenu;

  t: any;
  lastSpeedTest = 0;
  get satelliteEnable(){
    return this.satelliteService.useSatellite();
  }
  async ngOnInit() {
    this.setHeaderInfo();
    this.getHomePage();
    this.vpnState = this.startUpService.vpnState;
    this.isMws = this.clinicData.gf.Is多媒體候診;

    if (!this.t) {
      await this.testSpeed();
    }
    //this.hasBug();
  }
  speedTip = '';
  latencyTip = '';
  networkWarning = false;
  async testSpeed() {
    
    this.lastSpeedTest = Date.now();
    var speed = await this.api2.SpeedTest();
    var speedUpload = speed.uploadSpeed > 1024 ? (speed.uploadSpeed / 1024).toFixed(1) + 'MB/s' : (speed.uploadSpeed).toFixed(1) + 'KB/s';
    var speedDownload = speed.downloadSpeed > 1024 ? (speed.downloadSpeed / 1024).toFixed(1) + 'MB/s' : (speed.downloadSpeed).toFixed(1) + 'KB/s';
    this.speedTip = `\n網速: ↑${speedUpload}, ↓${speedDownload}`;
    this.latencyTip = `\n延遲: ${speed.roundTripTime}ms (↑${speed.toServerDelay},↓${speed.fromServerDelay})`;
    var notifyMsg = [];
    this.networkWarning = false;
    if (speed.uploadSpeed <= 10) {
      notifyMsg.push(`上傳速率過低(${speedUpload})`)
    }
    if (speed.downloadSpeed <= 50) {
      notifyMsg.push(`下載速率過低(${speedDownload}KB/s)`)
    }
    if (speed.roundTripTime > 1000) {
      notifyMsg.push(`網路延遲過高(${speed.roundTripTime}ms)`)
    } else if (notifyMsg.length > 0) {
      notifyMsg.push(`當前網路延遲:${speed.roundTripTime}ms`)
    }
    if (notifyMsg.length > 0) {
      notifyMsg = [`設備：[${this.hcrService.hcrConsoleComp?.consoleInfo?.ComputerName ?? '(無法取得名稱)'}]網路異常：`, ...notifyMsg];
      this.networkWarning = true;
      await this.api2.Notify(...notifyMsg);
    }

    // 網頁背景化時會多個interval一起執行 用settimeout執行一次才註冊下一次
    if (FunctionEnable.EnableAutoSpeedTest) {
      this.t = setTimeout(() => {
        this.testSpeed();
      }, 30000);
    }
  }
  x = 300;
  y = 300;
  dir = 180;
  bug: any = null;
  hasBug() {
    setInterval(() => {
      this.dir = this.dir + Math.random() * 4 - 2
      var deg = this.dir / 180 * Math.PI;
      var dist = Math.random() * 0.5 + 1.5;
      this.y += Math.sin(deg) * dist;
      this.x -= Math.cos(deg) * dist;
      this.bug = { top: this.y + 'px', right: this.x + 'px', transform: 'rotateZ(' + this.dir + 'deg)' }
    }, 16);
  }

  setHeaderInfo() {
    const user = UserCache.getLoginUser();
    this.companyName = user.CompanyName;
    this.companyCode = user.CompanyCode;
    this.clinicName = user.Clinic.Name;
    this.userName = user.Name || user.Account;
    this.clinicCode = user.Clinic.Code;
    // this.customerServiceExt = (user.Clinic.CustomerServiceExt??'') + (user.Clinic.ServicePhone??'');
    // ServicePhone 查詢失敗時後端回空字串，需 fallback 到診所的客服電話
    this.customerServiceExt = user.Clinic.ServicePhone || user.Clinic.CustomerServiceExt || '';
    this.getNowPharName();
  }

  onTopLeftBtnClick() {
    this.mainLayoutService.switchMenu();
  }

  // // user menu
  // onUserNameClick(isShow?: boolean): void {
  //   this.switchUserMenu();
  // }

  // // 這個是為了點user menu以外的地方時，user menu會自動關閉
  // @HostListener('document:click', ['$event'])
  // public documentClick(event: any): void {
  //   if (!this.contains(event.target)) {
  //     this.switchUserMenu(false);
  //   }
  // }
  contains(target: any): boolean {
    return (
      this.userLabel.nativeElement.contains(target) ||
      (this.userMenu ? this.userMenu.nativeElement.contains(target) : false)
    );
  }
  // switchUserMenu(isShow?: boolean): void {
  //   this.isShowUserMenu = isShow !== undefined ? isShow : !this.isShowUserMenu;
  // }
  closeUserMenu() {
    this.isShowUserMenu = false;
  }
  // ./user menu

  onLogout() {
    if (this.routeInfo.CurrentUrl.startsWith("/" + this.companyCode + "/hist/record")) {
      this.notificationDI.showInfo('目前看診中，請先退出看診畫面，才可執行登出操作。');
      return;
    }
    this.authService.logout();
  }
  isOpenSecureSetting = false
  userSecurity: UserSecurity = {
    LastChangePasswordTime: '尚未變更過密碼',
    TwoFactorValue: TwoFactorValue.None,
    Email: '',
    Phone: ''
  }
  TwoFactorDescOpt = TwoFactorDesc
  async onSecurity() {
    var userData = await this.clinicData.GetCurrentUser();
    this.userSecurity.LastChangePasswordTime = userData.lastChangePasswordTime == null ? '尚未變更過密碼' : DateHelper.formatROCDateTime(userData.lastChangePasswordTime,true,true);
    this.userSecurity.TwoFactorValue = userData.twoFactorValue;
    this.userSecurity.Email = userData.email;
    this.userSecurity.Phone = userData.phone;
    this.isOpenSecureSetting = true;
    //await this.startUpService.showChangePwd();
  }
  closeSecureSetting() {
    this.isOpenSecureSetting = false;
  }
  async saveSecureSetting() {
    try{
      await this.userApi.updateSecurity(this.userSecurity)
      this.notificationDI.showSuccess('更新完成')
      this.closeSecureSetting();
    }catch(e){
      this.notificationDI.showSuccess(e)
    }
  }
  async sendTest() {
    var target = '';
    var name = '';
    switch (this.userSecurity.TwoFactorValue) {
      case TwoFactorValue.EMAIL:
        target = this.userSecurity.Email;
        name = '信箱';
        break;
      case TwoFactorValue.SMS:
        target = this.userSecurity.Phone;
        name = '手機';
        break;
      default:
        await this.userConfirm.showAlert('無效的測試', '請選擇驗證方式');
        return;
    }
    try {
      var code = await this.userApi.Test2FV(this.userSecurity.TwoFactorValue, target);
      var ret = await this.ezForm.show({
        title: '請輸入驗證碼',
        msg: '驗證碼已傳送至您的' + name,
        fields: {
          code: {
            name: 'code',
            type: 'text',
            label: '驗證碼',
            value: ''
          }
        },
        closeValue: () => null
      });
      if (ret?.code) {
        await this.userConfirm.showAlert('驗證結果', ret.code == code ? '驗證成功' : '驗證失敗');
      }
    } catch (e) {
      await this.userConfirm.showAlert('發送失敗',JSON.stringify(e));
    }
  }
  /** 變更密碼 */
  async onPassword() {
    //const companyCode = this.routeInfo.getCompanyCode();
    //this.router.navigate([companyCode + '/system/user/changepassword']);
    await this.startUpService.showChangePwd();
  }

  // change clinic
  get currentClinicId(): number {
    return UserCache.getLoginUser().Clinic.Id;
  }
  isCurrentClinicId(id: number) {
    if (id === this.currentClinicId) {
      return true;
    } else {
      return false;
    }
  }
  async openChangeClinicDialog() {
    // Core單一登入尚未實作這個
    var comp = UserCache.getLoginUser().CompanyCode
    var ac = UserCache.getLoginUser().Account
    var clinics = await this.authService.getClinics(comp, ac).toPromise();
    this.allowedClinics = clinics;
    this.isOpenChangeClinicDialog = true;
    return;

  }
  closeChangeClinicDialog() {
    this.isOpenChangeClinicDialog = false;
  }

  async onClickClinic(id: number) {
    if (id === this.currentClinicId) {
      return;
    }
    this.mainLayoutService.showLoader();
    await this.authService.changeClinic(id)
    // this.authService.changeClinic(id).subscribe(
    //   isOk => {
    //     if (isOk) {
    //       this.closeChangeClinicDialog();
    //       this.setHeaderInfo();
    //       this.routeInfo.goHome();
    //       this.mainLayoutService.hideLoader();
    //       this.notificationDI.showOk();
    //     } else {
    //       this.notificationDI.showFailed();
    //       this.mainLayoutService.hideLoader();
    //     }
    //   },
    //   error => {
    //     this.notificationDI.showError(error);
    //     this.mainLayoutService.hideLoader();
    //   },
    //   () => {
    //   }
    // );
  }

  // closeMenu() {
  //   this.triggers.forEach(item => {
  //     item.closeMenu();
  //   });
  // }
  showHiddenModePwd = false;
  openMenu2(evt: MouseEvent) {
    this.showHiddenModePwd = true;
    evt.preventDefault();
    this.trigger.openMenu()
  }
  closeMenu() {
    this.showHiddenModePwd = false;
  }
  async openSPwdInput() {
    var pwd = ['503j;4u835.', '展望亞洲', '503J;4U835.']
    var ret = await this.ezForm.show({
      title: '測試人員模式',
      msg: '請輸入通關密語',
      fields: {
        'Pwd': {
          type: 'pwd',
          label: '密碼',
          name: 'Pwd',
          value: '',
        }
      },
      beforeSubmit: async (d) => {
        if (!pwd.some(x => x == d.Pwd)) {
          this.notificationDI.showWarning('很遺憾，通關失敗！');
          return false;
        } else {
          return true;
        }
      }
    });
    var debugModeFlag = localStorage.getItem('DebugMode');
    if (pwd.some(x => x == ret.Pwd)) {
      var modes = [
        { text: '開發人員', value: 'T' },
        { text: '正式環境', value: 'F' },
        { text: '無', value: '' },
      ];
      var ret2 = await this.ezForm.show({
        title: '測試人員模式',
        msg: '當前模式：' + (modes.find(x => x.value == debugModeFlag)?.text ?? '無') + '\n' +
          '開發人員：開啟系統管理者功能\n' +
          '正式環境：強制關閉系統管理者功能\n' +
          '無：功能回歸站台環境或帳號預設\n' +
          '注意：變更模式後會重新整理頁面。',
        fields: {
          'Mode': {
            type: 'dropdown',
            label: '模擬模式',
            name: 'Mode',
            data: modes,
            value: debugModeFlag
          }
        },
        closeValue: (d) => null
      });
      if (ret2?.Mode != null) {
        if (ret2.Mode == debugModeFlag) {
          this.notificationDI.showWarning('模式未變更');
        } else {
          localStorage.setItem('DebugMode', ret2.Mode);
          location.reload();
        }
      } else {
        this.notificationDI.showWarning('模式未變更');
      }
    }
  }
  ngOnDestroy() {
    this.isShowMenuSubscription.unsubscribe();
    this.isShowPharSubscription.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  openSettingDialog() {
    this.startUpService.showSelectPhar();
  }

  // 取得首頁url
  private getHomePage() {
    var loginUser = UserCache.getLoginUser();
    var companyCode = loginUser.CompanyCode;
    var loginpath = 'system/announcement';
    this.logopath = '/' + companyCode + '/' + loginpath;
    this.logopathfg = loginpath != null && loginpath != '' ? true : false;
  }

  // 簡易轉址 詳情可參考 menu.component.ts 之 redirectTo
  async redirectTo(url: string, closefg: boolean) {
    // console.log('closefg', closefg);
    // 目前在門診登錄(看診)畫面，不可導到首頁
    if (this.routeInfo.CurrentUrl.startsWith("/" + this.companyCode + "/hist/record")) {
      this.notificationDI.showInfo('目前看診中，請先退出看診畫面，才可執行其他非看診作業之操作。');
      return;
    }
    // 如果 選單功能/YourPage 為關閉則不啟用轉址
    if (!closefg) {
      return
    }
    if (this.router.url == url) {
      return
    }
    var canRedirect = await this.routeInfo.onMenuClick();
    if (canRedirect == false) {
      return;
    }
    // this.eventService.fire(EventKey.ShowLoading,true);
    setTimeout(() => {
      //this.eventService.fire(EventKey.MenuChanged,menuItem.text);
      this.router.navigateByUrl(url);

      // 把目前掛的comp清掉
      this.routeInfo.comp = null;
    }, 0);
  }
  vpnState: VPNState = 'Fail';
  // pingRs:(boolean)=>void;
  pingWait = null;
  reloadAngle = 0;
  async Ping_VPN(notifyEr: boolean = true) {
    this.pingWait = true;
    try {
      var interval = setInterval(() => {
        this.reloadAngle += Math.PI / 10;
      }, 100)
      await this.startUpService.Ping_VPN()
      clearInterval(interval);
    } catch (e) {
      if (notifyEr) {
        this.notificationDI.showWarning(e);
      }
    }
    this.pingWait = false;
    this.vpnState = this.startUpService.vpnState;

  }

  async cacheReload(evt: MouseEvent) {
    if (BaseConfig.isDebug()) {
      evt.preventDefault();
      this.mainLayoutService.showLoader();
      try {
        await this.clinicData.reload();
        this.notificationDI.showSuccess('重載完成');
      } catch (e) {
        this.notificationDI.showError('重載失敗');
      }
      this.mainLayoutService.hideLoader();
    }

  }

  /** 取得登入時選擇的 值班藥師 */
  getNowPharName() {
    var ph = this.startUpService.getPharyList();
    var defaPharId = this.sessionService.getPhar();
    var pOpt = ph?.find(p => p.value == defaPharId);
    if (pOpt) {
      this.headerPharName = pOpt.text;
    } else {
      this.headerPharName = '無藥師';
    }
  }
  get idleTime() {
    return this.startUpService.waitTime;
  }
  manualEnableNotifyLog = false;
  enableNotifyLog(evt: Event) {
    evt.preventDefault();
    evt.stopPropagation();
    this.manualEnableNotifyLog = !this.manualEnableNotifyLog;
  }
}
